const nutritionInformationEnumerators = {
  standardWeight: 100,
  labelFormat: ['basic_label', 'standard_label', 'tabbed_label'],
  servingSizeUnit: ['ml', 'g'],
  vitaminDataFormat: ['percentage', 'unit'],
  vitamins: [
    { name: 'vitaminA', unit: 'mcg' },
    { name: 'vitaminD', unit: 'mcg' },
    { name: 'vitaminE', unit: 'mg' },
    { name: 'vitaminK', unit: 'mcg' },
    { name: 'vitaminC', unit: 'mg' },
    { name: 'thiamin', unit: 'mg' },
    { name: 'riboflavin', unit: 'mg' },
    { name: 'niacin', unit: 'mg' },
    { name: 'vitaminB6', unit: 'mg' },
    { name: 'folicAcid', unit: 'mcg' },
  ],
  optionalVitamins: [
    { name: 'vitaminB12', unit: 'mcg' },
    { name: 'biotin', unit: 'mcg' },
    { name: 'pantothenicAcid', unit: 'mg' },
    { name: 'potassium', unit: 'mg' },
    { name: 'chloride', unit: 'mg' },
    { name: 'calcium', unit: 'mg' },
    { name: 'phosphorus', unit: 'mg' },
    { name: 'magnesium', unit: 'mg' },
    { name: 'iron', unit: 'mg' },
    { name: 'zinc', unit: 'mg' },
    { name: 'copper', unit: 'mg' },
    { name: 'manganese', unit: 'mg' },
    { name: 'fluoride', unit: 'mg' },
    { name: 'selenium', unit: 'mcg' },
    { name: 'chromium', unit: 'mcg' },
    { name: 'molybdenum', unit: 'mcg' },
    { name: 'iodine', unit: 'mcg' },
  ],
};

export const NUTRIENTS = [
  {
    required: true,
    type: 'totalFat',
    subTypes: [
      { key: 'saturatedFat', mandatory: true },
      { key: 'monounsaturatedFat', mandatory: false },
      { key: 'polyunsaturatedFat', mandatory: false },
    ],
  },
  {
    required: true,
    type: 'totalCarbohydrates',
    subTypes: [
      { key: 'sugars', mandatory: true },
      { key: 'polyols', mandatory: false },
      { key: 'starch', mandatory: false },
    ],
  },
  {
    required: true,
    type: 'protein',
    subTypes: [],
  },
  {
    required: true,
    type: 'salt',
    subTypes: [],
  },
  {
    required: false,
    type: 'dietaryFiber',
    subTypes: [],
  },
];

export default nutritionInformationEnumerators;
